/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EarnedPaymentsStatsByMethodResponse } from '../../models/earned-payments-stats-by-method-response';

export interface BookingControllerGetWalletEarnedPaymentsByMethod$Params {
}

export function bookingControllerGetWalletEarnedPaymentsByMethod(http: HttpClient, rootUrl: string, params?: BookingControllerGetWalletEarnedPaymentsByMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EarnedPaymentsStatsByMethodResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetWalletEarnedPaymentsByMethod.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EarnedPaymentsStatsByMethodResponse;
      }>;
    })
  );
}

bookingControllerGetWalletEarnedPaymentsByMethod.PATH = '/booking/wallet/earned_payments/stats-by-method';
